import React, { FC, useState } from 'react'
import {
  FilterAutocomplete,
  IFilterAutocompleteProp,
  IFilterAutocompleteProps,
  ISuggestResult,
  isAutosuggestResult,
  loadSuggestions,
  resultMatch,
  searchResultLabel,
  useFilterAutocomplete,
} from 'transfix-ui/components/FilterAutocomplete'
import { useDebouncedCallback } from 'use-debounce/lib'
import { CustomerIcon } from 'transfix-icons'

interface CarrierFilterAutocomplete extends Partial<IFilterAutocompleteProps<ISuggestResult>> {
  onSelectedValue: (val: IFilterAutocompleteProp) => void
}

/**
 * Autocomplete Filters for selecting Carriers with Customer icon
 */
const CarrierFilterAutocomplete: FC<CarrierFilterAutocomplete> = ({
  label = 'Customer',
  onSelectedValue: onSelectedValueProps,
  toggleClear = false,
}) => {
  const [value, setValue] = useState<ISuggestResult | undefined | null>()
  const { reducerDispatch: dispatchCarrier, reducerState: carrierState } = useFilterAutocomplete()

  const carrierInputChangeHandler = (_: React.ChangeEvent<{}>, value: string) => {
    loadSuggestions({ value, type: 'carrier', dispatch: dispatchCarrier })
  }

  const setValueHandler = (val: IFilterAutocompleteProp) => {
    if (isAutosuggestResult(val)) {
      setValue(val)
    } else {
      setValue(null)
    }
    onSelectedValueProps(val)
  }

  const [debounceSearchCarrier] = useDebouncedCallback(carrierInputChangeHandler, 250)

  return (
    <FilterAutocomplete
      id='carrier-filter-autocomplete-component'
      label={label}
      placeholder='Search'
      dataTest='carrier-filter-autocomplete-component'
      options={carrierState.results || []}
      value={value}
      setValue={setValueHandler}
      onInputChange={debounceSearchCarrier}
      getOptionLabel={searchResultLabel}
      getOptionSelected={resultMatch}
      filterOptions={options => options}
      quickSuggest
      autoSelect={false}
      toggleClear={toggleClear}
      resultsLoading={carrierState.loading}
      icon={<CustomerIcon size='large' />}
    />
  )
}

export default CarrierFilterAutocomplete
